<template>
    <div class="wrap">
        <el-table :data="tableData.my_list" :header-cell-style="{ background: '#F5F7FA', color: '#454D53' }">
            <div slot="empty">
                <img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 70%; padding: 20px 0 0" />
            </div>
            <el-table-column :label="item.label" :prop="item.prop" :width="item.width" v-for="(item, index) in tableHeaderList" :type="item.prop" :key="index">
                <template slot="header" slot-scope="scope">
                    <div v-if="item.tip" style="cursor: pointer;">
                        <el-tooltip placement="top">
                        <div slot="content" v-html="item.tip"></div>
                        <div>{{ item.label }}<i class="el-icon-question question-icon"></i></div>
                        </el-tooltip>
                    </div>
                    <div v-else>
                        {{ item.label }}
                    </div>
                </template>
                <template slot-scope="scope">
                    <div>
                        <!-- {{ scope.row[item.prop] ? scope.row[item.prop] : "--" }} -->
                        {{ scope.row[item.prop] }}
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin-top: 10px;font-size: 14px;">
            应收款总金额：{{ tableData.my_total_money }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tableData: { // table数据
            type: Object,
            default: ()=>{
                return {
                    my_list: [],
                    my_total_money: '--'
                }
            }
        }
    },
    data() {
        return {
            noDataName: "empty",
            tableHeaderList: [
                {
                    prop: "come_from_desc",
                    label: "渠道",
                },
                {
                    prop: "pay_time_range",
                    label: "订单成交时间",
                },
                {
                    prop: "settle_gmv",
                    label: "结算gmv",
                    tip: "与豆包平台结算的订单gmv",
                    width: 120,
                },
                {
                    prop: "settle_count",
                    label: "结算单数",
                    tip: "与豆包平台结算的订单数",
                    width: 120,
                },
                {
                    prop: "payment",
                    label: "应收款金额",
                },
            ]
        }
    }
}
</script>

<style scoped lang="less">

</style>